
"use client";

import {
  Footer,
  FooterBrand,
  FooterCopyright,
  FooterDivider,
  FooterIcon,
  FooterLink,
  FooterLinkGroup,
  FooterTitle,
} from "flowbite-react";
import { BsDribbble, BsFacebook, BsGithub, BsInstagram, BsTwitter } from "react-icons/bs";
import logo from '../assets/logo.png'
import logo2 from '../assets/logo - Copy.png'
import { useNavigate } from "react-router-dom";

const FooterComponent = () => {
    const navigate = useNavigate();
    const handlePpClick = () => {
        navigate('/user/privacy-policy');
    }
  return (
    <Footer container>
      <div className="w-full">
        <div className="grid w-full justify-between sm:flex sm:justify-between md:flex md:grid-cols-1">
          <div className="flex items-center justify-center space-x-4 sm:justify-start md:justify-start">
            <FooterBrand
              href="https://flowbite.com"
              src= {logo}
              alt="Flowbite Logo"
     
            />
              <FooterBrand
              href="https://flowbite.com"
              src= {logo2}
              alt="Flowbite Logo"
   
            />
          </div>
          <div className="grid grid-cols-2 gap-8 sm:mt-4 sm:grid-cols-3 sm:gap-6">
            <div>
              <FooterTitle title="about" />
              <FooterLinkGroup col>
                <FooterLink href="#"></FooterLink>
                <FooterLink href="#">Broadwater</FooterLink>
              </FooterLinkGroup>
            </div>
            <div>
              <FooterTitle title="Follow us" />
              <FooterLinkGroup col>
                <FooterLink href="#">Facebook</FooterLink>
                <FooterLink href="#">Instagram</FooterLink>
              </FooterLinkGroup>
            </div>
            <div>
              <FooterTitle title="Legal" />
              <FooterLinkGroup col>
                <FooterLink onClick={handlePpClick}>Privacy Policy</FooterLink>
                <FooterLink href="#">Terms &amp; Conditions</FooterLink>
              </FooterLinkGroup>
            </div>
          </div>
        </div>
        <FooterDivider />
        <div className="w-full sm:flex sm:items-center sm:justify-between">
          <FooterCopyright href="#" by="Broadwater Marine Inc.™" year={2025} />
          <div className="mt-4 flex space-x-6 sm:mt-0 sm:justify-center">
            <FooterIcon href="#" icon={BsFacebook} />
            <FooterIcon href="#" icon={BsInstagram} />
          </div>
        </div>
      </div>
    </Footer>
  );
}; export default FooterComponent;
